"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sfType = exports.isONSCode = exports.coordsAsXY = exports.properties = exports.propertyCount = exports.getKeyColumns = exports.arrayPlotProps = exports.getPropertyValues = exports.isColumnAllNumeric = exports.propertyCountByProperty = exports.describeFeatureVariables = void 0;

var _JSUtils = require("./JSUtils");

var _utils = require("./utils");

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var sfType = function sfType(geojson) {
  if (geojson.type === "FeatureCollection") {
    return "FeatureCollection";
  }

  if (geojson.type === "GeometryCollection") {
    return "GeometryCollection";
  }

  if (geojson.type === "Feature" && geojson.geometry !== null) {
    return geojson.geometry.type;
  }

  return geojson.type;
};

exports.sfType = sfType;

var properties = function properties(geojson) {
  if (!geojson || !geojson.features) return null;
  var properties = geojson.features[0].properties;
  return Object.keys(properties);
};

exports.properties = properties;

var getKeyColumns = function getKeyColumns(geojson) {
  if (!geojson || !geojson.features) return null;
  var keys = [];
  var all_property_counts = getPropertyValues(geojson);
  Object.keys(all_property_counts).forEach(function (column) {
    if (Array.from(all_property_counts[column]).length === geojson.features.length) {
      keys.push(column);
    }
  });
  return keys.length > 0 ? keys : null;
};

exports.getKeyColumns = getKeyColumns;

var isONSCode = function isONSCode(array) {
  if (!array || array.length === 0) return false;
  var result = true;
  array.forEach(function (e) {
    if (!(0, _JSUtils.isString)(e) || e.length !== 9 || !e.match(/^[EWS]\d{2}.{6}$/)) {
      result = false;
    }
  });
  return result;
};

exports.isONSCode = isONSCode;

var describeFeatureVariables = function describeFeatureVariables(feature) {
  if (!feature || feature.type !== 'Feature') return null;
  var description = {};
  Object.keys(feature.properties).forEach(function (key) {
    var v_type = String;
    var value = feature.properties[key];

    if ((0, _utils.isStringDate)(value)) {
      v_type = Date;
    } else if ((0, _JSUtils.isNumber)(value)) {
      v_type = Number;
    } else if ((0, _JSUtils.isBoolean)(value)) {
      v_type = Boolean;
    } else if ((0, _JSUtils.isObject)(value)) {
      v_type = Object;
    }

    description[key] = v_type;
  });
  return description;
};

exports.describeFeatureVariables = describeFeatureVariables;

var getPropertyValues = function getPropertyValues(geojson, property) {
  if (!geojson || !geojson.features) return null;
  var all = {};
  var values = new Set();
  geojson.features.forEach(function (feature) {
    feature.properties && Object.keys(feature.properties) && Object.keys(feature.properties).forEach(function (each) {
      if (property && property === each) {
        values.add(feature.properties[each]);
      } else {
        if (_typeof(all[each]) === 'object') {
          all[each].add(feature.properties[each]);
        } else {
          all[each] = new Set();
          all[each].add(feature.properties[each]);
        }
      }
    });
  });
  return property ? Array.from(values) : all;
};

exports.getPropertyValues = getPropertyValues;

var propertyCount = function propertyCount(data, key, list) {
  if (!data || !key) return;
  var sub_data = [];
  var list_copy = list;

  if (!list || list.length === 0) {
    list_copy = getPropertyValues({
      features: data
    }, key);
  }

  data.forEach(function (feature) {
    Object.keys(feature.properties).forEach(function (each) {
      if (each === key) {
        var i = list_copy.indexOf(feature.properties[each]);

        if (sub_data[i] && sub_data[i].x === feature.properties[each]) {
          sub_data[i].y += 1;
        } else {
          sub_data[i] = {
            x: feature.properties[each],
            y: 1
          };
        }
      }
    });
  });
  return sub_data;
};

exports.propertyCount = propertyCount;

var propertyCountByProperty = function propertyCountByProperty(data, key, key2) {
  var year = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  if (!data || !key || !key2 || key === key2) return;
  var sub_data = {};
  data.forEach(function (feature) {
    var props = feature.properties;
    if (!props || !Object.keys(props)) return;
    var k2 = year && new Date(props[key2]) && new Date(props[key2]).getFullYear() ? new Date(props[key2]).getFullYear() : props[key2];
    Object.keys(props).forEach(function (each) {
      if (each === key) {
        if (sub_data[k2] && sub_data[k2][props[each]]) {
          sub_data[k2][props[each]] += 1;
        } else {
          sub_data[k2] = Object.assign(sub_data[k2] || {}, _defineProperty({}, props[each], 1));
        }
      }
    });
  });
  return sub_data;
};

exports.propertyCountByProperty = propertyCountByProperty;

var coordsAsXY = function coordsAsXY(geojson, sizeProperty) {
  if (!geojson.features) return null;
  return geojson.features.map(function (each) {
    var result = {
      x: each.geometry.coordinates[0],
      y: each.geometry.coordinates[1]
    };

    if (sizeProperty && each.properties[sizeProperty]) {
      result.size = each.properties[sizeProperty];
    }

    return result;
  });
};

exports.coordsAsXY = coordsAsXY;

var isColumnAllNumeric = function isColumnAllNumeric(data, columnNameOrIndex) {
  if (!Array.isArray(data) && (!(0, _JSUtils.isString)(columnNameOrIndex) || !(0, _JSUtils.isNumber)(columnNameOrIndex))) return null;
  var isNumeric = true;
  data.forEach(function (d) {
    if (!(0, _JSUtils.isStringNumeric)(d.properties[+columnNameOrIndex || +columnNameOrIndex === 0 ? Object.keys(d.properties)[columnNameOrIndex] : columnNameOrIndex])) {
      isNumeric = false;
    }
  });
  return isNumeric;
};

exports.isColumnAllNumeric = isColumnAllNumeric;

var arrayPlotProps = function arrayPlotProps(data, property) {
  var empty = {
    data: [],
    type: null
  };
  if (!data || !Array.isArray(data) || !data.length || !property) return empty;
  var array = data.map(function (e) {
    return e.properties[property];
  });
  var unique = (0, _utils.uniqueValuePercentage)(array, 95);
  var allNumbers = [];
  data.forEach(function (f) {
    var v = f.properties[property];
    if ((0, _JSUtils.isStringNumeric)(v)) allNumbers.push(v);
  });
  var percentage = allNumbers.length / array.length * 100;
  var mostlyNumbs = allNumbers.length > 10 ? percentage > 95 : percentage > 50;
  if (unique && !mostlyNumbs) return empty;
  var props = {
    data: mostlyNumbs ? data.map(function (e, i) {
      return {
        x: i,
        y: e.properties[property]
      };
    }) : (0, _utils.xyObjectByProperty)(data, property),
    type: mostlyNumbs ? "continuous" : "cardinal"
  };
  return props;
};

exports.arrayPlotProps = arrayPlotProps;